import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

@Component({
  selector: 'app-snack-bar',
  templateUrl: './snack-bar-simple.component.html',
  styleUrl: './snack-bar-simple.component.scss',
})
export class SnackBarSimpleComponent {
  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any) {}
}
